export default __webpack_public_path__ + "static/media/Wrong_Answer.654bcc9c.png";